export default "__VITE_ASSET__BTiDeeyf__"